import { render } from "./PanamericanosCHV.vue?vue&type=template&id=1367806c"
import script from "./PanamericanosCHV.vue?vue&type=script&lang=js"
export * from "./PanamericanosCHV.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__